
<div [ngStyle]="{'width.px': width}">
  <div class="wrapper" [ngStyle]="{'max-height.px': maxHeight}" [tabindex]="isReadonly ? -1 : 0">
    <table cdkDropListGroup attr.aria-labelledby="{{parentFieldId}}-label" attr.aria-describedby="{{parentFieldId}}-description {{parentFieldId}}-subtext">
      <!-- Header -->
      <thead>
        <tr>
          <th class="fixed-col first-col table-header"><input *ngIf="!isReadonly && !hasInitError()" type="checkbox" #selectAll type="checkbox" (click)="selectAllDocs(selectAll.checked)"></th>
          <th [ngStyle]="getColumnStyle('name')">{{ 'lf_fileset_doc_name' | localize: lfFilesetLocalizeHelper }}</th>
    
          <th *ngFor="let dHeader of viewModel.columns" [ngStyle]="getColumnStyle(dHeader.key)">{{dHeader.header}}</th>
          <th class="fixed-col last-col table-header"></th>
        </tr>
      </thead>


      <ng-container *ngIf="hasInitError()">
        <tbody>
          <tr><td class="fileset-init-error-message" [attr.colspan]="getColspan()">{{initErrorMsg}}</td></tr>
        </tbody>
      </ng-container>

      <ng-container *ngIf="!hasInitError()">
        <tbody *ngFor="let dType of viewModel.types; index as typeIndex" cdkDropList [cdkDropListDisabled]="isReadonly" (cdkDropListDropped)="rowDropped($event)" [cdkDropListData]="dType">
          
          <!-- Type Header -->
          <tr *ngIf="dType.id != '_none_' || (dType.files.length != 0 && viewModel.types.length > 1)">
            <td [ngClass]="{'validation-error': hasTypeError(dType) }" [attr.colspan]="getColspan()" style="font-weight: 600;">
              <span class="fixed-col type-col">
                <span>{{dType.name}}</span><span *ngIf="isTypeRequired(dType.id)" class="required-star">*</span>
                <span *ngIf="dType.id != '_none_' && dType.min != dType.max" style="font-weight: 400;">{{ { key: 'lf_fileset_type_requirements', args: [dType.min, dType.max] } | localize: lfFilesetLocalizeHelper }}</span>
                <span *ngIf="dType.id != '_none_' && dType.min == dType.max" style="font-weight: 400;">{{ { key: 'lf_fileset_type_requirements_same_min_max', args: [dType.max] } | localize: lfFilesetLocalizeHelper }}</span>
              </span>
             
              <span class="fixed-col type-right-col type-icon" *ngIf="!isReadonly && dType.id != '_none_' && importMode">
                <button type="button" icon-button (click)="onTypeImport(dType.id)" title="{{ 'lf_fileset_import' | localize: lfFilesetLocalizeHelper }}">
                  <svg class="tool-bar-icon">
                      <use xlink:href="#_svg-file-upload"></use>
                  </svg>
                </button>
              </span>
            </td>
          </tr>

          <!-- Individual Files -->
          <tr *ngFor="let dFile of dType.files; index as i" cdkDrag class="row-data">
            <td class="fixed-col first-col" [ngClass]="{'cell-data': hasStatusDropdown(false)}"><input *ngIf="!isReadonly" type="checkbox" [checked]="dFile.viewModel.isSelected" (change)="dFile.viewModel.isSelected = !dFile.viewModel.isSelected"></td>
            
            <td [ngStyle]="getColumnStyle('name')" [ngClass]="{'cell-data': hasStatusDropdown(false)}">
              <a href="javascript:void(0)" title="{{dFile.name}}" (click)="onOpenDocument(dFile.id)">{{dFile.name}}</a>
            </td>

            <td *ngFor="let dHeader of viewModel.columns" [ngStyle]="getColumnStyle(dHeader.key)" [ngClass]="{'cell-data': hasStatusDropdown(dHeader.key == 'status')}">
              <span *ngIf="dHeader.key != 'status'" title="{{dHeader.cell(dFile)}}">{{dHeader.cell(dFile)}}</span>

              <!-- Status Column -->
              <ng-select *ngIf="!isReadonly && dHeader.key == 'status' && docStatuses.length > 1" class="custom" [(ngModel)]="dFile.status"
                [ngClass]="{'validation-error': hasFileError(dFile) }" 
                (change)="onStatusChange(dFile)" 
                [searchable]="false" 
                [clearable]="false" 
                [clearOnBackspace]="false" 
                appendTo=".fileset-status-container">
                <ng-option *ngFor="let aStatus of docStatuses" [value]="aStatus.key">{{aStatus.display}}</ng-option>
              </ng-select>
              <span *ngIf="dHeader.key == 'status' && (isReadonly || docStatuses.length == 1)">{{ getStatusDisplay(dFile.status)}}</span>
              <!-- --- -->
              
            </td>

            <td class="fixed-col last-col" [ngClass]="{'cell-data': hasStatusDropdown(false)}">
              <button type="button" icon-button *ngIf="!isReadonly" (click)="onInlineRemove(dType.files, dFile, i)" title="{{ 'lf_fileset_remove' | localize: lfFilesetLocalizeHelper }}" >
                <svg class="tool-bar-icon">
                  <use xlink:href="#_svg-close"></use>
                </svg>
              </button>
            </td>
          </tr>

        </tbody>
      </ng-container>
    </table>
  </div>
</div>

